import { render, staticRenderFns } from "./RateSelect.vue?vue&type=template&id=10ad08c8&scoped=true"
import script from "./RateSelect.vue?vue&type=script&lang=js"
export * from "./RateSelect.vue?vue&type=script&lang=js"
import style0 from "./RateSelect.vue?vue&type=style&index=0&id=10ad08c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ad08c8",
  null
  
)

export default component.exports